import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useDeleteSingleLotMutation } from '../../features/api/rest/apiLotsSlice';
import { setAlertMessage } from '../../features/layoutSlice';

function DeleteLotDialog({ isOpen, setIsOpen, ean, opk, id }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [deleteLot] = useDeleteSingleLotMutation();

  const handleDelete = async () => {
    try {
      await deleteLot({ ean, opk, id });
      dispatch(setAlertMessage({ text: t('organizations.product.lots.deleteLot.successMessage'), type: 'success' }));
    } catch (error) {
      dispatch(setAlertMessage({ text: t('organizations.product.lots.deleteLot.errorMessage'), type: 'error' }));
    } finally {
      setIsOpen(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <DialogTitle sx={{ textAlign: 'center' }}>{t('organizations.product.lots.deleteLot.dialog.title')}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" mx={4}>
          {t('organizations.product.lots.deleteLot.confirmMessage')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ pt: 0, pb: 3, px: 3 }}>
        <Grid container display="flex" justifyContent="space-between" gap={1}>
          <Grid item>
            <Button type="submit" onClick={() => setIsOpen(false)} variant="outlined" color="secondary">
              {t('common.actions.close')}
            </Button>
          </Grid>
          <Grid item>
            <Button type="submit" onClick={handleDelete} variant="contained" color="warning">
              {t('common.actions.delete')}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteLotDialog;

DeleteLotDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  ean: PropTypes.string.isRequired,
  opk: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
